import DataTables from '../../components/dataTables.js';

class PaymentDevicesMove {
  constructor() {
    this.$ = window.$;
    this.attach();
  }

  get dom() {
    return {
      DATATABLES: '.dataTables',
    };
  }

  attach() {
    var $table = this.$(this.dom.DATATABLES),
      dataTableOpts;

    dataTableOpts = {
      data: window.payment_devices,
      columns: window.paymentDeviceColumns,
      el: $table,
      filter: true,
      fixed: false,
      sorting: [[0, 'asc']],
    };

    this.dataTable = new DataTables(dataTableOpts);
    this.dataTable.start();
    this.$('.select2select').select2();
  }
}

module.exports = PaymentDevicesMove;
